export const KM_OFFER_TEST_IDS = {
    OFFER_WRAPPER: "offer-wrapper",
    ASK_FOR_OFFER: "ask-for-offer-button",
    OFFER_DETAILS: "offer-details-button",
    DETAILS_ASK_FOR_OFFER: "details-ask-for-offer-button",
    DETAILS_ASK_FOR_OFFER_MOBILE: "details-ask-for-offer-button-mobile",
    DETAILS_ASK_FOR_OFFER_DESKTOP: "details-ask-for-offer-button-desktop",
    OFFER_GALLERY: "offer-gallery",
    SHOW_PHONE_NUM: "show-phone-num-button",
    LIKE_BUTTON: "thumb-up",
    DISLIKE_BUTTON: "thumb-down",
    EXPANDABLE_SECTION: "expandable-section-button",
    RESTORE_BUTTON: "restore-button",
    DISMISS_BUTTON: "dismiss-button",
    CONFIRM_SEND_LEAD: "confirm-send-lead-button",
    AFTER_LIKE_MODAL: "after-like-modal",
    AFTER_DISLIKE_MODAL: "after-dislike-modal",
    THUMB_UP: "thumb-up",
    THUMB_DOWN: "thumb-down",
    PROPERTY_BOX: "property-box",
    PROPERTY_BOX_PRICE: "property-box-price",
    DETAIL_VIEW: "property-detail-view",
    DETAIL_THREAD_SIDEBAR: "property-detail-thread-sidebar",
    PHONE_MODAL: "property-phone-modal",
    PHONE_REVEALED: "property-phone-revealed"
};
export const KM_OFFER_TEST_IDS = {
    OFFER_WRAPPER: "offer-wrapper",
    ASK_FOR_OFFER: "ask-for-offer-button",
    OFFER_DETAILS: "offer-details-button",
    DETAILS_ASK_FOR_OFFER: "details-ask-for-offer-button",
    DETAILS_ASK_FOR_OFFER_MOBILE: "details-ask-for-offer-button-mobile",
    DETAILS_ASK_FOR_OFFER_DESKTOP: "details-ask-for-offer-button-desktop",
    OFFER_GALLERY: "offer-gallery",
    SHOW_PHONE_NUM: "show-phone-num-button",
    LIKE_BUTTON: "thumb-up",
    DISLIKE_BUTTON: "thumb-down",
    EXPANDABLE_SECTION: "expandable-section-button",
    RESTORE_BUTTON: "restore-button",
    DISMISS_BUTTON: "dismiss-button",
    CONFIRM_SEND_LEAD: "confirm-send-lead-button",
    AFTER_LIKE_MODAL: "after-like-modal",
    AFTER_DISLIKE_MODAL: "after-dislike-modal",
    THUMB_UP: "thumb-up",
    THUMB_DOWN: "thumb-down",
    PROPERTY_BOX: "property-box",
    PROPERTY_BOX_PRICE: "property-box-price",
    DETAIL_VIEW: "property-detail-view",
    DETAIL_THREAD_SIDEBAR: "property-detail-thread-sidebar",
    PHONE_MODAL: "property-phone-modal",
    PHONE_REVEALED: "property-phone-revealed"
};
